import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import AdminService from '@/services/admin.service';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/DenyModal.css';

function DenyModalContent({ close, draftId }) {
  const { cacheHandler } = useStateHandler();
  const [denyReason, setDenyReason] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function denyArtworkRequest() {
    setLoading(true);

    if(!denyReason) {
      alert("Introduce the reason, please.");
      setLoading(false);
      return;
    }

    const { response } = await AdminService.rejectArtworkRequestAndNotifyChanges(draftId, denyReason);

    setLoading(false);

    if(response.ok) {
      alert("The request for the artwork has been rejected successfully.");
      cacheHandler.triggerAction("ARTWORK_REQUEST_DENIED");
      navigate("/admin/artwork-requests", { replace: true });
    } else {
      alert("Something went wrong, please try again later.");
    }
  }

  return (
    <>
      <Text
        className="admin-deny-artwork-modal__text font-size-small"
        paragraph
        justify>
        Next, specify to the gallery the reasons why your work has been rejected. 
      </Text>
      <PublicFormInput
        placeholder='Rejection reasons'
        className="admin-deny-artwork-modal__textarea"
        type="textarea"
        value={denyReason}
        onChange={e => setDenyReason(e.target.value)}
      />
      <div className="admin-deny-artwork-modal__options element-non-selectable">
        <Text
          className="admin-deny-artwork-modal__option cancel font-size-small"
          onClick={close}>
                    Cancel
        </Text>

        <Text
          className={[
            `admin-deny-artwork-modal__option deny ${loading ? "read-only" : ""}`,
            "font-size-small"
          ].filter(Boolean).join(" ")}
          onClick={denyArtworkRequest}>
          {loading ? "Loading..." : "Deny artwork request"}
        </Text>
      </div>
    </>
  );
}

export default function DenyModal({ open, close, draftId }) {
  return (
    <>
      <GenericPopup open={open} className="admin-deny-artwork-modal" opacity>
        <DenyModalContent close={close} draftId={draftId}/>
      </GenericPopup>
    </>
  );
}
